import React from 'react';
import classnames from 'classnames';
import CategoryMapPage from '../../../CategoryMapPage';
import FilterBar from '../../components/FilterBar';
import { filterBar as filterBarStyles } from './styles.module.css';
import { filterBarContainer } from '../../styles.module.css';
import { headerHeight } from '../../../../base-styles/vars';

const mapStyleDefault = {
  // takes out header and filterbar (48px)
  height: `calc(var(--vh, vh) * 100 - ${headerHeight} - 48px)`,
  width: 'calc(100vw - (100vw - 100%))', // full width minus potential scrollbar
};

const FindDesktopLayout = ({
  categoryData,
  searchParams,
  dataLoading,
  ...props
}) => {
  return (
    <>
      <div className={classnames(filterBarContainer, filterBarStyles)}>
        <FilterBar />
      </div>
      <CategoryMapPage
        data={{ categoryData, loading: dataLoading }}
        searchParams={searchParams}
        isExternalMap
        hideBackClick
        mapStyle={mapStyleDefault}
        {...props}
      />
    </>
  );
};

export default FindDesktopLayout;
